<template>
  <f7-link
    @click="scanQRCode()"
    icon-ios="f7:qrcode_viewfinder"
    icon-md="material:qr_code_scanner"
    :aria-label="$t('common.scan')"
  >
  </f7-link>
</template>
<script setup>
import { useScanQRCode } from '@/js/composables/useScanQRCode.js'

const props = defineProps({
  f7route: Object,
  f7router: Object,
});

const { scanQRCode } = useScanQRCode({ f7route: props.f7route, f7router: props.f7router });
</script>